export class Utils {
  static createFormData = (data, form = null, namespace = null) => {
    const formData = form || new FormData();

    for (const key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) continue;

      const value = data[key];
      const formKey = namespace ? `${namespace}[${key}]` : key;

      if (value instanceof Date) {
        formData.append(formKey, value.toISOString());
      } else if (value instanceof File) {
        formData.append(formKey, value);
      } else if (typeof value === 'object' && value !== null) {
        // recurse for objects or arrays
        this.createFormData(value, formData, formKey);
      } else if (value !== undefined && value !== null) {
        formData.append(formKey, String(value));
      }
    }

    return formData;
  };
}
